import { Box, Heading, HStack, VStack } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { Route, Routes } from 'react-router-dom';
import { PrivacyPolicyPage } from './components/PrivacyPolicy';
import { Logo } from '../../components/atoms/Logo';
import { ScrollToTop } from '../../utils';
import TermsBePartner from './components/TermsBePartner';
import { TermsOfUse } from './components/TermsOfUse';
import { IoIosArrowRoundBack } from 'react-icons/io';

function LegalPageTemplate({ title, children }: { title: string } & PropsWithChildren) {
  return (
    <>
      <ScrollToTop />
      <VStack
        backgroundColor={'white'}
        borderLeft={'1px solid #dedede'}
        borderRight={'1px solid #dedede'}
        w={'90%'}
        maxW={'700px'}
        padding={{ base: '20px 10%', lg: '20px 40px' }}
      >
        <Box width={'100%'} >
          <Heading
            as="button"
            size="sm"
            onClick={() => {
              if (window.history.length > 1) {
                window.history.back();
              } else {
                window.location.href = '/';
              }
            }}
            color="blue.500"
            _hover={{ textDecoration: 'underline' }}
          >
            <HStack>
              <IoIosArrowRoundBack color={"black"} size={30} />
            </HStack>
          </Heading>
        </Box>
        <Logo />
        <Heading paddingBottom={'20px'} paddingTop={'20px'}>
          {title}
        </Heading>

        {children}
      </VStack>
    </>
  );
}

export function LegalPage() {
  return (
    <VStack backgroundColor={'#FAFAFA'} w={'100%'}>
      <Routes>
        <Route
          path="/politica-de-privacidade"
          element={
            <LegalPageTemplate title="Política de Privacidade">
              <PrivacyPolicyPage />
            </LegalPageTemplate>
          }
        />
        <Route
          path="/termos-de-uso"
          element={
            <LegalPageTemplate title="Termos de Uso">
              <TermsOfUse />
            </LegalPageTemplate>
          }
        />
        <Route
          path="/be-partner/termos-de-uso"
          element={
            <LegalPageTemplate title="Termos de Uso - Seja Parceiro">
              <TermsBePartner />
            </LegalPageTemplate>
          }
        />
      </Routes>
    </VStack>
  );
}
